module.exports = __webpack_public_path__ + "img/Borrow.1c47762d.svg";